import { render, staticRenderFns } from "./ConfigEditor.vue?vue&type=template&id=5365aee4&scoped=true&"
import script from "./ConfigEditor.vue?vue&type=script&lang=js&"
export * from "./ConfigEditor.vue?vue&type=script&lang=js&"
import style0 from "./ConfigEditor.vue?vue&type=style&index=0&id=5365aee4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5365aee4",
  null
  
)

export default component.exports